import React from "react";
import ApplicationInfoCard from "@/components/cards/ApplicationInfoCard";
import ApplicationStatusBar from "@/components/applications/ApplicationStatusBar";
import ApplicationDetailCard from "@/components/applications/ApplicationDetailCard";
import SubApplicantsDetailCard from "@/components/applications/SubApplicantsDetailCard";

import { applicants } from "@/data/application-data";
import { subApplicants } from "@/data/sub-applicant-data";
import SideNavLayout from "@/layouts/SideNavLayout";

const ScreeningPage = () => {
  const applicant = applicants[0];

  return (
    <SideNavLayout>
      <div className="container mt-3">
        <div className="row">
          <div className="col col-md-4">
            <ApplicationDetailCard {...applicant} />
            <SubApplicantsDetailCard data={subApplicants} />
          </div>
          <div className="col">
            {/* <ApplicationStatusBar status="docs_received" variant="success" /> */}
            <ApplicationInfoCard />
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

ScreeningPage.propTypes = {};

export default ScreeningPage;
